import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './schrift';
import { TrainerApp } from './TrainerApp';
import { Auffangnetz } from './komponenten/Auffangnetz';
import './stil.css';

/**
 * Einstiegspunkt des Trainerbereichs (`trainer.html`, RES-27).
 *
 * Er bindet NICHT `App` ein, und das ist der ganze Zweck: Was hier nicht
 * eingebunden ist, landet nicht im Bündel und damit nicht auf dem Telefon des
 * externen Dienstleisters (RES-30, RES-31). Siehe TrainerApp.tsx.
 *
 * Das Wurzelelement heißt in beiden Seiten gleich. Zwei Namen wären zwei
 * Stellen, an denen sich ein Tippfehler als weiße Seite zeigt.
 */
const wurzel = document.getElementById('wurzel');

if (!wurzel) {
  throw new Error('Wurzelelement #wurzel fehlt');
}

createRoot(wurzel).render(
  <StrictMode>
    {/* Dasselbe Netz wie im CRM: Ein Fehler beim Rendern nimmt sonst den
        ganzen Baum mit und hinterlässt eine weiße Seite ohne Text (ERR-11). */}
    <Auffangnetz>
      <TrainerApp />
    </Auffangnetz>
  </StrictMode>,
);
